import classNames from 'classnames';
import React from 'react';
import styles from './BaseGrid.scss.js';

const BaseGrid = _ref => {
  let {
    columns = 4,
    elements,
    vGap = 24,
    hGap = 16,
    gridRef = null,
    shouldRemoveLineHeight = false,
    isHorizontallyCentered = true
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    ref: gridRef,
    className: classNames({
      [styles.wrapper]: true,
      [styles['np-base']]: true,
      [styles['np-base--no-line-height']]: shouldRemoveLineHeight,
      [styles['np-base--is-centered']]: isHorizontallyCentered
    }),
    style: {
      gridColumnGap: `${hGap}px`,
      gridRowGap: `${vGap}px`,
      gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
    }
  }, elements?.map((element, index) => {
    // TODO: Review this key
    const elementKey = `${element.key}_${`${index}`}`;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item,
      key: elementKey
    }, element);
  }));
};
var BaseGrid$1 = BaseGrid;

export { BaseGrid$1 as default };
//# sourceMappingURL=BaseGrid.js.map
